import PropTypes from 'prop-types';


export const flagEnabled = (flag) =>
  ['1', 1].includes(process.env[`REACT_APP_FLAG_${flag?.toUpperCase()}`] ?? 0);

flagEnabled.propTypes = {
  flag: PropTypes.string.isRequired,
};

export const consoleLog = (label, data, debugOverride = false) => {
  if (!flagEnabled('debugging') && !debugOverride) return;
  console.log(`[${label}]`, data);
};

